import { StepSchema, CaseSchema } from '@feedyou/schema'
import { Dialogs } from '../components/steps/types'

export function findDeadEnds(dialogs: Dialogs) {
  const possible = new Set<string>()
  const definite = new Set<string>()

  let prevPossibleSize
  let prevDefiniteSize

  while (shouldCheck(possible, definite, prevPossibleSize, prevDefiniteSize)) {
    prevPossibleSize = possible.size
    prevDefiniteSize = definite.size

    checkForNestedDeadEnds(dialogs, possible, definite)
  }

  return { possible, definite }
}

function shouldCheck(
  possible: Set<string>,
  definite: Set<string>,
  prevPossibleSize?: number,
  prevDefiniteSize?: number
): boolean {
  if (possible.size !== prevPossibleSize) {
    return true
  }
  if (definite.size !== prevDefiniteSize) {
    return true
  }

  return false
}

function checkForNestedDeadEnds(dialogs: Dialogs, possible: Set<string>, definite: Set<string>) {
  Object.entries(dialogs).forEach(([dialogId, { steps }]) => {
    steps.forEach((step: StepSchema) => {
      switch (step.type) {
        case 'action':
          if (
            [
              'endConversation',
              'endConversationWithHandoff',
              'triggerHandoff',
              'triggerHandoffWithoutEmail'
            ].includes(step.action)
          ) {
            definite.add(dialogId)
          }
          break

        case 'dialog':
        case 'postpone':
        case 'timeout':
          if (step.disabled || step.condition === 'false') {
            break
          }
          if (step.dialog && possible.has(step.dialog)) {
            possible.add(dialogId)
          }

          if (step.dialog && definite.has(step.dialog)) {
            if (step.condition) {
              possible.add(dialogId)
            } else {
              definite.add(dialogId)
            }
          }

          break

        case 'question':
          //case 'multiquestion': // do not used
          if (step.answers) {
            checkCases(step.answers, dialogId, possible, definite)
          }
          break

        case 'switch':
          const cases = step.cases ? [...step.cases] : []

          if (step.default) {
            cases.push(step.default)
          }

          checkCases(cases, dialogId, possible, definite)
          break
        default:
      }
    })
  })
}

function checkCases(
  cases: CaseSchema[],
  dialogId: string,
  possible: Set<string>,
  definite: Set<string>
) {
  if (
    cases.some(
      ({ dialog }: CaseSchema) => definite.has(dialog as any) || possible.has(dialog as any)
    )
  ) {
    possible.add(dialogId)
  }

  if (cases.every(({ dialog }: CaseSchema) => definite.has(dialog as any))) {
    definite.add(dialogId)
  }
}
